export const EVENT_NAME = {
  WAGER_REWARDS: "OPT-IN TO WAGER REWARDS",
  SUCCESS: "Opt-In Success",
  ERROR: "Opt-In Error",
  FIND_A_RACE: "Find a Race",
  CASH_IN: "Cash In",
  SELECT_FILTER: "Select Filter",
  SEE_ALL_HISTORY: "See All History"
};
